import IndFamWizard from './components/IndFamWizard';

export default function App() {
  return <IndFamWizard />;
}
